import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: ":categoryId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "categoryId" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [],
});
